export default __webpack_public_path__ + "static/media/control-foto3.5e84b1ed.jpg";